import React, { useMemo } from 'react';
import { ThemeProvider } from '@mui/material';

import { createTheme } from '../theme';

import { useTenantContext } from './TenantProvider';

const HEX_COLOR = /^#[0-9A-Fa-f]{6}$/;

type Props = {
  children: React.ReactNode;
};

export const TenantThemeProvider: React.FC<Props> = ({ children }) => {
  const { tenant } = useTenantContext();
  const brandColor = tenant?.isWhiteLabel
    ? tenant.brand.primaryColorHex
    : undefined;

  const theme = useMemo(
    () =>
      brandColor && HEX_COLOR.test(brandColor) ? createTheme(brandColor) : null,
    [brandColor],
  );

  if (!theme) {
    return <>{children}</>;
  }

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
